// assets/slider-banner.js
// Vanilla JS slider, tidak butuh dependency apapun.
// Otomatis bekerja untuk setiap instance section (support multiple slider di 1 halaman)
// dan reload otomatis saat block ditambah/diedit/dihapus di Theme Editor.

class SliderBanner {
  constructor(root) {
    this.root = root;
    this.sectionId = root.dataset.sectionId;
    this.track = root.querySelector('.slider-banner__track');
    this.slides = Array.from(root.querySelectorAll('.slider-banner__slide'));
    this.dots = Array.from(root.querySelectorAll('.slider-banner__dot'));
    this.prevBtn = root.querySelector('.slider-banner__arrow--prev');
    this.nextBtn = root.querySelector('.slider-banner__arrow--next');

    this.autoplay = root.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(root.dataset.autoplaySpeed, 10) || 5000;
    this.pauseOnHover = root.dataset.pauseOnHover === 'true';

    this.currentIndex = 0;
    this.timer = null;

    if (this.slides.length <= 1) return; // tidak perlu logic slider kalau cuma 1 slide

    this.updateOffsets();
    this.bindEvents();
    if (this.autoplay) this.startAutoplay();
  }

  // Mengatur posisi relatif tiap slide (dipakai oleh efek "slide")
  // offset -1 = di kiri slide aktif, 0 = aktif, 1 = di kanan slide aktif, dst.
  updateOffsets() {
    this.slides.forEach((slide, i) => {
      const offset = i - this.currentIndex;
      slide.style.setProperty('--sb-offset', offset);
    });
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex - 1);
        this.restartAutoplay();
      });
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.goTo(this.currentIndex + 1);
        this.restartAutoplay();
      });
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.dotIndex, 10);
        this.goTo(index);
        this.restartAutoplay();
      });
    });

    if (this.pauseOnHover) {
      this.root.addEventListener('mouseenter', () => this.stopAutoplay());
      this.root.addEventListener('mouseleave', () => {
        if (this.autoplay) this.startAutoplay();
      });
    }

    // Swipe support (touch)
    let startX = 0;
    let isDragging = false;

    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    this.track.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      if (Math.abs(diff) > 40) {
        if (diff > 0) {
          this.goTo(this.currentIndex + 1);
        } else {
          this.goTo(this.currentIndex - 1);
        }
        this.restartAutoplay();
      }
    }, { passive: true });

    // Pause autoplay saat tab tidak aktif
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.stopAutoplay();
      } else if (this.autoplay) {
        this.startAutoplay();
      }
    });

    // Reload slider kalau section di-edit lewat Theme Editor
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector(`#SliderBanner-${this.sectionId}`)) {
        const newRoot = event.target.querySelector(`#SliderBanner-${this.sectionId}`);
        new SliderBanner(newRoot);
      }
    });

    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('.slider-banner__slide');
      if (!slide) return;
      const index = parseInt(slide.dataset.slideIndex, 10);
      this.stopAutoplay();
      this.goTo(index);
    });

    document.addEventListener('shopify:block:deselect', () => {
      if (this.autoplay) this.startAutoplay();
    });
  }

  goTo(index) {
    const total = this.slides.length;
    const newIndex = (index + total) % total;

    this.slides[this.currentIndex].classList.remove('is-active');
    this.slides[this.currentIndex].setAttribute('aria-hidden', 'true');

    this.slides[newIndex].classList.add('is-active');
    this.slides[newIndex].setAttribute('aria-hidden', 'false');

    if (this.dots.length) {
      this.dots[this.currentIndex].classList.remove('is-active');
      this.dots[this.currentIndex].setAttribute('aria-selected', 'false');
      this.dots[newIndex].classList.add('is-active');
      this.dots[newIndex].setAttribute('aria-selected', 'true');
    }

    this.currentIndex = newIndex;
    this.updateOffsets();
  }

  startAutoplay() {
    this.stopAutoplay();
    this.timer = setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  restartAutoplay() {
    if (this.autoplay) this.startAutoplay();
  }
}

function initSliderBanners() {
  document.querySelectorAll('.slider-banner').forEach((root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    new SliderBanner(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSliderBanners);
} else {
  initSliderBanners();
}